module.exports = __webpack_public_path__ + "media/images/riders/MALENE_DEGN-b78e118d0747cc602eb74dd75ff96661.png";